// libs
import React, { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

const SIZE_UNITS = [
    { value: '', label: 'None (e.g. S, M, L)' },
    { value: 'inches', label: 'Inches' },
    { value: 'cm', label: 'cm' },
    { value: 'feet', label: 'Feet' },
];

function FormModal({loadapidata, setshowformmodalbox, orgaccountid, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        label: "",
        unit: "",
        sortOrder: 0,
    });
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false : true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' });
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false);
    }

    const onSubmit = async (data) => {
        if (!orgaccountid) {
            toast.error('Choose a seller account on the list page first');
            return;
        }
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            accountId: orgaccountid,
            rowId: rowid || 0,
            label: data.label,
            unit: data.unit || '',
            sortOrder: data.sortOrder ?? 0
        };
        let apiCall = "";
        if (InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/size`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/size`, postData, token);
        }
        if (apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            hideModal();
            loadapidata();
        } else {
            setSubmitButton((InputFields.rowId) ? 'UPDATE RECORD' : 'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/size/row`, {
                    rowId: rowid
                }, token);
                if (apiCall && apiCall.status) {
                    let d = apiCall.context.message.data[0];
                    setInputFields({
                        rowId: rowid,
                        label: d.label,
                        unit: d.unit || '',
                        sortOrder: d.sort_order,
                    });
                    setNotification({ status: false });
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' });
                }
            }
        }
        fetchData();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid ? 'Update Size' : 'Add Size'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Size Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Size Value</label>
                                            <input type="text" defaultValue={InputFields.label} className="form-control" {...register("label", { required: true, minLength: 1, maxLength: 18 })} disabled={disabledField} placeholder="e.g. 12, S, M" />
                                            <small className="form-text text-danger">
                                                {errors.label?.type === "required" && "Size value is mandatory"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Unit</label>
                                            <Controller
                                                name="unit"
                                                defaultValue={InputFields.unit}
                                                control={control}
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" onChange={(e) => field.onChange(e.target.value)} disabled={disabledField}>
                                                        {SIZE_UNITS.map((u) => (
                                                            <option key={u.value || 'none'} value={u.value}>{u.label}</option>
                                                        ))}
                                                    </select>
                                                )}
                                            />
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Sort Order</label>
                                            <input type="number" defaultValue={InputFields.sortOrder} className="form-control" {...register("sortOrder")} disabled={disabledField} placeholder="0" />
                                            <small className="form-text text-muted">Lower numbers appear first in dropdowns</small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;
